module.exports = "<a class=mui-group-item href=javascript:> <div class=\"mui-group-item-bd mui-group-item-primary\"> <p>{{title}}</p> <inline-desc v-if=inlineDesc>{{inlineDesc}}</inline-desc> </div> <div class=\"mui-group-item-ft with-arrow dp-value\">{{value}}</div> </a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datetime/index.vue
 ** module id = 155
 ** module chunks = 0
 **/